import { render, staticRenderFns } from "./ShowInteressent.vue?vue&type=template&id=0fa0081b&scoped=true"
import script from "./ShowInteressent.vue?vue&type=script&lang=js"
export * from "./ShowInteressent.vue?vue&type=script&lang=js"
import style0 from "./ShowInteressent.vue?vue&type=style&index=0&id=0fa0081b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0081b",
  null
  
)

export default component.exports